/* =============================================================================
   ILHA · PÁGINA INICIAL NOVA (direção C «Stories») · o comportamento
   Um ficheiro só, carregado com `defer` por cada secção `ilha-c-*`: a guarda
   `window.__ilhaC` faz com que corra uma vez, por muitas vezes que venha na página.

   ⛔ Se este ficheiro não correr, NADA se perde: o HTML já sai completo e visível.
      Aqui só se acrescenta movimento e troca de estado. Nunca se esconde para depois revelar.
   ⛔ Quem pediu menos movimento: o cartaz não passa sozinho e o vídeo não arranca sozinho.
   ⛔ Nada de escrever HTML por texto: tudo por nós do DOM (textContent, createElementNS).
   ============================================================================= */
(function () {
  'use strict';
  if (window.__ilhaC) return;
  window.__ilhaC = true;

  var menos = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var poupar = navigator.connection && navigator.connection.saveData;
  var SVG = 'http://www.w3.org/2000/svg';

  function todos(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }
  function recomecar(el, classe) { el.classList.remove(classe); void el.offsetWidth; el.classList.add(classe); }
  function aoCentro(fila, el) {
    if (!fila || !el) return;
    fila.scrollTo({ left: el.offsetLeft - fila.clientWidth / 2 + el.offsetWidth / 2, behavior: menos ? 'auto' : 'smooth' });
  }
  function trocarDesenho(svg, d) {
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', d);
    svg.appendChild(p);
  }

  /* ---------------------------------------------------------------------------
     STORIES: o anel fica cinzento depois de visto (só neste browser, por conveniência).
     --------------------------------------------------------------------------- */
  function stories() {
    var chave = 'ilha_c_vistos';
    var vistos = [];
    try { vistos = JSON.parse(localStorage.getItem(chave) || '[]'); } catch (e) { vistos = []; }
    if (!Array.isArray(vistos)) vistos = [];
    todos('.ic-story').forEach(function (s) {
      var url = s.getAttribute('href');
      if (vistos.indexOf(url) !== -1) s.classList.add('ic-visto');
      s.addEventListener('click', function () {
        if (vistos.indexOf(url) === -1) vistos.push(url);
        try { localStorage.setItem(chave, JSON.stringify(vistos.slice(-40))); } catch (e) { /* sem espaço: não faz mal */ }
      });
    });
  }

  /* ---------------------------------------------------------------------------
     CARTAZ: como os stories. Passa sozinho, pára com o dedo em cima, toque à direita
     avança e à esquerda recua, e pára de vez ao fim de uma volta.
     Num slide de vídeo, a barra dura o que o vídeo dura (até 15 s), e o vídeo só toca
     enquanto o slide está à frente e o cartaz está no ecrã.
     --------------------------------------------------------------------------- */
  function cartaz(c) {
    var slides = todos('.ic-slide', c);
    var barras = todos('.ic-cartaz__barras button', c);
    if (!slides.length) return;
    var atual = 0, noEcra = true, deVez = false, aMao = false, pausa = null;
    var dur = parseFloat(c.getAttribute('data-dur')) || 5;

    // Com vídeo do computador há dois `<video>` no slide e o CSS esconde um: toca-se o que se vê.
    var mqPc = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
    function videoDe(k) {
      var s = slides[k];
      if (!s) return null;
      var pc = s.querySelector('video.ic-v-pc');
      if (pc && mqPc && mqPc.matches) return pc;
      return s.querySelector('video:not(.ic-v-pc)');
    }
    function tocar(k) {
      slides.forEach(function (s, i) {
        var certo = videoDe(i);
        todos('video', s).forEach(function (v) {
          if (v === certo && i === k && s.icCapa && noEcra && !aMao && !menos && !poupar) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      });
    }
    /* ⭐ 07/10/2026 · Só o 1.º cartaz vem com as fotos no HTML (`ilha-c-cartaz.liquid`). Os outros
       trazem o endereço em `data-ic-*` e ACORDAM aqui: o seguinte logo que a foto do atual chega,
       e qualquer um no momento em que passa para a frente (toque, barra ou a vez dele).
       ⚠️ Primeiro os `<source>`, depois o `<img>`: ao contrário, o navegador escolhia a foto do
       telemóvel antes de saber que havia uma para o computador, e descarregava as duas. */
    function acordar(s) {
      if (!s || s.icAcordado) return;
      s.icAcordado = true;
      todos('source[data-ic-srcset]', s).forEach(function (e) { e.setAttribute('srcset', e.getAttribute('data-ic-srcset')); e.removeAttribute('data-ic-srcset'); });
      todos('img[data-ic-srcset]', s).forEach(function (e) { e.setAttribute('srcset', e.getAttribute('data-ic-srcset')); e.removeAttribute('data-ic-srcset'); });
      todos('img[data-ic-src]', s).forEach(function (e) { e.setAttribute('src', e.getAttribute('data-ic-src')); e.removeAttribute('data-ic-src'); });
      todos('video[data-ic-poster]', s).forEach(function (v) { v.setAttribute('poster', v.getAttribute('data-ic-poster')); v.removeAttribute('data-ic-poster'); });
      /* ⭐ 08/10/2026 · O VÍDEO SÓ PARTE DEPOIS DA CAPA, E SÓ O QUE SE VÊ. Os `<video>` do cartaz vêm
         com preload="none" e sem `poster` (a capa é a `<picture>` por trás). Quem os põe a andar é o
         `tocar`, e só quando as fotos deste cartaz já chegaram: antes, o vídeo tirava a rede à capa,
         que é a maior imagem do primeiro ecrã. ⛔ Não acordar aqui os dois `<video>`: o escondido
         (o do computador, num telemóvel) descarregava inteiro sem ninguém o ver, 2,6 MB medidos. */
      quandoChegar(s, function () { s.icCapa = true; if (slides[atual] === s) tocar(atual); });
    }
    /* ⚠️ Reparos das auditorias de 07/10:
       · o `ir(0)` do arranque acordava o 2.º cartaz logo, antes de a foto do 1.º chegar (a espera
         pelo `load` era código morto): agora nada acorda sozinho enquanto `podeAcordar` for falso;
       · em rede lenta, saltar para um cartaz ainda a dormir deixava-o 1 a 1,6 s só com a cor de
         fundo: agora os cartazes acordam EM FILA, um quando as fotos do anterior já chegaram, e ao
         fim de poucos segundos estão todos prontos sem nunca concorrerem com a foto do primeiro. */
    var podeAcordar = false;
    function acordarOSeguinte() { if (podeAcordar && slides.length > 1) acordar(slides[(atual + 1) % slides.length]); }
    function quandoChegar(s, f) {
      var falta = todos('img', s).filter(function (i) { return i.getAttribute('src') && !i.complete; });
      var n = falta.length;
      if (!n) { f(); return; }
      falta.forEach(function (i) {
        var visto = false;
        function um() { if (visto) return; visto = true; n -= 1; if (n === 0) f(); }
        i.addEventListener('load', um);
        i.addEventListener('error', um);
      });
    }
    function acordarEmFila(k) {
      if (k >= slides.length) return;
      acordar(slides[k]);
      quandoChegar(slides[k], function () { acordarEmFila(k + 1); });
    }
    function ir(n) {
      var vinha = atual;
      atual = (n + slides.length) % slides.length;
      acordar(slides[atual]);
      acordarOSeguinte();
      slides.forEach(function (s, i) { s.classList.toggle('ic-esta', i === atual); s.setAttribute('aria-hidden', i === atual ? 'false' : 'true'); });
      c.classList.toggle('ic-cartaz--escuro', slides[atual].classList.contains('ic-slide--video') && !slides[atual].classList.contains('ic-slide--claro'));
      var v = videoDe(atual);
      // Ao voltar a um cartaz com vídeo, ele recomeça do início, a par da barra.
      if (v && vinha !== atual && v.readyState > 0) { try { v.currentTime = 0; } catch (e) { /* recomeça de onde estava */ } }
      var d = dur;
      if (v && isFinite(v.duration) && v.duration > 0) d = Math.min(v.duration, 15);
      // Vídeo que ainda não disse quanto dura (vem a dormir): a barra espera o máximo, e recomeça
      // certa no `loadedmetadata`. Com os segundos de uma foto, o cartaz passava antes de ele tocar.
      else if (v && !menos && !poupar) d = 15;
      c.style.setProperty('--dur', d + 's');
      barras.forEach(function (b, i) { b.classList.remove('ic-esta'); b.classList.toggle('ic-feito', i < atual); b.setAttribute('aria-current', i === atual ? 'true' : 'false'); });
      if (barras[atual]) { void barras[atual].offsetWidth; barras[atual].classList.add('ic-esta'); }
      tocar(atual);
    }
    barras.forEach(function (b, k) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); deVez = false; parar(false); c.classList.remove('ic-parado'); ir(k); });
      var i = b.querySelector('i');
      if (i) i.addEventListener('animationend', function () {
        if (k !== atual || deVez) return;
        // ⭐ 08/10/2026 · Ordem do Silva: o cartaz dá a volta sem fim. Depois do último vem o
        // primeiro (o `ir` faz a conta). Antes parava no último e a campanha do 1.º não voltava.
        ir(atual + 1);
      });
    });
    if (slides.length > 1) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        var r = c.getBoundingClientRect();
        ir(atual + ((e.clientX - r.left) < r.width * .3 ? -1 : 1));
      });
    }
    c.addEventListener('pointerdown', function () { c.classList.add('ic-parado'); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      c.addEventListener(ev, function () { if (!deVez) c.classList.remove('ic-parado'); });
    });
    slides.forEach(function (s, k) {
      todos('video', s).forEach(function (v) {
        v.addEventListener('loadedmetadata', function () { if (k === atual && v === videoDe(k)) ir(atual); });
      });
    });
    if (mqPc && mqPc.addEventListener) mqPc.addEventListener('change', function () { ir(atual); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { noEcra = en.isIntersecting; tocar(atual); c.classList.toggle('ic-parado', !noEcra || deVez); });
      }, { threshold: .35 }).observe(c);
    }
    // Os outros cartazes só começam a acordar quando a foto do 1.º já chegou: antes disso
    // estavam a tirar-lhe a rede. Depois acordam em fila, um de cada vez.
    quandoChegar(slides[0], function () { podeAcordar = true; acordarEmFila(1); });
    if (menos || slides.length < 2) { deVez = true; c.classList.add('ic-parado'); }
    /* ⭐ 09/10/2026 · Botão de PARAR (auditoria): o que roda sozinho tem de se poder parar (WCAG 2.2.2).
       Só aparece quando os cartazes rodam; tocar numa barra volta a pôr a rodar. */
    function parar(sim) {
      aMao = sim; deVez = sim;
      if (pausa) { pausa.setAttribute('aria-pressed', sim ? 'true' : 'false'); pausa.setAttribute('aria-label', sim ? 'Continuar os cartazes' : 'Parar os cartazes'); }
      c.classList.toggle('ic-parado', sim || !noEcra);
      tocar(atual);
    }
    if (!menos && slides.length > 1) {
      pausa = document.createElement('button');
      pausa.type = 'button';
      pausa.className = 'ic-cartaz__pausa';
      pausa.innerHTML = '<svg class="ic-p-parar" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg><svg class="ic-p-seguir" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>';
      pausa.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); parar(!aMao); });
      c.appendChild(pausa);
      c.classList.add('ic-cartaz--com-pausa');
      parar(false);
    }
    ir(0);
  }

  /* ---------------------------------------------------------------------------
     SEPARADORES DA MONTRA: a aba acende, a grelha troca com uma cascata curta.
     --------------------------------------------------------------------------- */
  function montra(m) {
    var abas = todos('.ic-aba', m);
    var ver = m.querySelector('.ic-ver-todos');
    abas.forEach(function (a) {
      a.addEventListener('click', function () {
        abas.forEach(function (x) {
          var sim = x === a;
          x.classList.toggle('ic-esta', sim);
          x.setAttribute('aria-selected', sim ? 'true' : 'false');
          x.tabIndex = sim ? 0 : -1;
          var g = document.getElementById(x.getAttribute('aria-controls'));
          if (!g) return;
          g.hidden = !sim;
          if (sim) { todos('.ic-prod', g).forEach(function (p, n) { p.style.setProperty('--n', n); }); recomecar(g, 'ic-entra'); }
        });
        if (ver) {
          var url = a.getAttribute('data-ver');
          ver.hidden = !url;
          if (url) { ver.href = url; ver.textContent = a.getAttribute('data-ver-texto') || ver.textContent; }
        }
        aoCentro(a.parentNode, a);
      });
      /* ⛔ TECLADO (auditorias de 01/10): as abas escondidas têm tabindex=-1, por isso as SETAS têm de
         levar de uma aba à outra, como manda o padrão dos separadores. Sem isto, só a 1.ª se alcançava. */
      a.addEventListener('keydown', function (e) {
        var i = abas.indexOf(a), n = -1;
        if (e.key === 'ArrowRight') n = (i + 1) % abas.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + abas.length) % abas.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = abas.length - 1;
        if (n < 0) return;
        e.preventDefault();
        abas[n].focus();
        abas[n].click();
      });
    });
  }

  /* ---------------------------------------------------------------------------
     ADICIONAR: só diz «Adicionado» quando o carrinho CONFIRMA (evento do tema
     `product-ajax:added`). Se o tema disser erro, o botão abana e volta ao que era.
     --------------------------------------------------------------------------- */
  var pendentes = [];
  function adicionar() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('.ic-prod__acao')) return;
      var campo = f.querySelector('[name=id]');
      pendentes.push({ id: String(campo ? campo.value : ''), botao: f.querySelector('.ic-adicionar'), quando: Date.now() });
    }, true);
    document.addEventListener('product-ajax:added', function (e) {
      var d = (e.detail && e.detail.product) || {};
      var ids = [String(d.variant_id || d.id || '')];
      if (Array.isArray(d.items)) d.items.forEach(function (it) { ids.push(String(it.variant_id || it.id)); });
      var resto = [];
      pendentes.forEach(function (p) {
        if (ids.indexOf(p.id) !== -1) marcar(p.botao);
        else if (Date.now() - p.quando < 15000) resto.push(p);
      });
      pendentes = resto;
    });
    /* ⛔ O ERRO SÓ MARCA O PEDIDO QUE FALHOU (auditoria de 01/10): o evento `product-ajax:error` do tema
       não diz QUAL pedido falhou, e limpar a fila toda apagava a confirmação de outro produto que tinha
       entrado. O tema publica o mesmo erro no `pubsub` COM o id da variante: é esse que se usa. Sem
       `pubsub`, cai-se no mais antigo da fila, e só nesse. */
    var comPubsub = false;
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.cartError) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, function (d) {
          var id = String((d && d.productVariantId) || '');
          var k = -1;
          for (var i = 0; i < pendentes.length; i++) { if (pendentes[i].id === id) { k = i; break; } }
          if (k === -1) return;
          if (pendentes[k].botao) recomecar(pendentes[k].botao, 'ic-erro');
          pendentes.splice(k, 1);
        });
        comPubsub = true;
      }
    } catch (e) { comPubsub = false; }
    document.addEventListener('product-ajax:error', function () {
      if (comPubsub || !pendentes.length) return;
      var p = pendentes.shift();
      if (p.botao) recomecar(p.botao, 'ic-erro');
    });
  }
  function marcar(b) {
    if (!b || b.classList.contains('ic-feito')) return;
    b.classList.add('ic-feito');
    b.setAttribute('aria-label', 'Adicionado ao carrinho');
    var svg = b.querySelector('svg');
    if (svg) trocarDesenho(svg, 'm5 12.5 4.5 4.5L19 7.5');
    var t = b.querySelector('span');
    if (t) t.textContent = 'Adicionado';
    // o saco do cabeçalho do tema pula com o número novo
    todos('.cart-count, .cart-count-bubble, [data-cart-count]').forEach(function (s) { recomecar(s, 'ic-saco-pulo'); });
  }

  /* ---------------------------------------------------------------------------
     OFERTA: tocar num tom troca a foto, o nome, a cor do fundo e o link do botão.
     Ao entrar no ecrã, uma vez: o risco passa no preço do brinde e o «Grátis» pousa.
     --------------------------------------------------------------------------- */
  function oferta(o) {
    var foto = o.querySelector('.ic-peca--tom img');
    var leg = o.querySelector('.ic-peca--tom figcaption');
    var bt = o.querySelector('.ic-oferta__botao');
    var fila = o.querySelector('.ic-tons');
    todos('.ic-tom', o).forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('ic-esta')) return;
        todos('.ic-tom', o).forEach(function (x) { var sim = x === t; x.classList.toggle('ic-esta', sim); x.setAttribute('aria-pressed', sim ? 'true' : 'false'); });
        if (t.dataset.cor) o.style.setProperty('--tom', t.dataset.cor);
        if (foto && t.dataset.img) {
          foto.classList.add('ic-sai');
          setTimeout(function () {
            foto.onload = function () { foto.classList.remove('ic-sai'); };
            foto.src = t.dataset.img;
            foto.alt = t.getAttribute('aria-label') || '';
          }, 160);
        }
        if (leg) {
          leg.textContent = 'Tom ' + (t.dataset.tom || '');
          var sm = document.createElement('small');
          sm.textContent = t.dataset.nome || '';
          leg.appendChild(sm);
        }
        if (bt && t.dataset.url) { bt.textContent = 'Ver o tom ' + (t.dataset.tom || ''); bt.href = t.dataset.url; }
        aoCentro(fila, t);
      });
    });
    var esc = fila && fila.querySelector('.ic-tom.ic-esta');
    if (esc) fila.scrollLeft = esc.offsetLeft - fila.clientWidth / 2 + esc.offsetWidth / 2;
    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { o.classList.add('ic-visto'); ob.disconnect(); } });
      }, { threshold: .45 });
      ob.observe(o);
    } else o.classList.add('ic-visto');
  }

  /* ---------------------------------------------------------------------------
     MERCADO: os filtros escondem e mostram, com a mesma cascata da montra.
     --------------------------------------------------------------------------- */
  function mercado(m) {
    var filaM = m.querySelector('.ic-mercado__fila');
    if (!filaM) return;
    todos('.ic-mfatia', m).forEach(function (f) {
      f.addEventListener('click', function () {
        todos('.ic-mfatia', m).forEach(function (x) { var sim = x === f; x.classList.toggle('ic-esta', sim); x.setAttribute('aria-pressed', sim ? 'true' : 'false'); });
        var n = 0;
        todos('.ic-prod', filaM).forEach(function (p) {
          var sim = f.dataset.cat === '*' || p.dataset.cat === f.dataset.cat;
          p.hidden = !sim;
          if (sim) p.style.setProperty('--n', n++);
        });
        recomecar(filaM, 'ic-entra');
        filaM.scrollTo({ left: 0, behavior: menos ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------------------------------------------------------------------------
     FILAS QUE DESLIZAM PARA O LADO (07/10/2026)
     Pedido do Silva, com a ideia da esposa: «o cliente não percebe que tem que virar o dedo.
     Quando vai descer na página, a fila mexe para a direita e para a esquerda, que assim mostra
     que pode mexer. Faz uma setinha.»

     Na primeira vez que uma fila com mais coisas do que cabem entra no ecrã, ESPREITA: anda 64 px
     e volta ao sítio, e enquanto isso uma SETA aparece na ponta, acena e apaga-se.

     ⛔ A SETA NÃO FICA PARADA POR CIMA DO CONTEÚDO (Silva, 07/10, ao ver a primeira versão: «aparece
        a setinha e apaga, para não ficar em cima como tá agora»). No telemóvel só existe durante a
        espreitadela. No computador, onde não há dedo, aparece também enquanto o rato está por cima
        da fila, porque aí é a única maneira de andar.

     ⛔ A espreitadela é UMA vez por fila e pára logo que a pessoa lhe toca. Depois de a cliente
        deslizar uma fila com o dedo, nenhuma outra volta a espreitar: já percebeu, e a partir daí
        era só ruído (fica lembrado no aparelho dela).
     ⛔ Quem pediu menos movimento não vê a espreitadela. As setas ficam.
     ⚠️ Mexe-se o `scrollLeft` a sério, não um `transform`: é a fila a deslizar de verdade, e um
        deslize dentro de uma fila não conta como salto de disposição (CLS).
     ⚠️ O carrossel das avaliações da Judge.me fica de fora: as avaliações não se mexem.
     --------------------------------------------------------------------------- */
  var FILAS = '.ic-stories, .ic-confianca, .ic-fila, .ic-cartoes, .ic-abas, .ic-tons, .ic-mercado__fatias, .ic-mercado__fila';
  function deslizar() {
    var CHAVE = 'ilha-c-ja-deslizou', aprendeu = false;
    try { aprendeu = localStorage.getItem(CHAVE) === '1'; } catch (e) { /* modo privado: espreita outra vez, não faz mal */ }
    function aprender() { if (aprendeu) return; aprendeu = true; try { localStorage.setItem(CHAVE, '1'); } catch (e) { /* sem espaço */ } }
    var rato = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var onda = 0;   // quantas filas entraram no ecrã agora mesmo: a seguinte espreita um pouco depois
    function botao(classe, rotulo) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ic-seta ' + classe; b.hidden = true;
      // No telemóvel a seta é só um aceno: não se toca nem entra na ordem do teclado.
      if (rato) b.setAttribute('aria-label', rotulo); else { b.setAttribute('aria-hidden', 'true'); b.tabIndex = -1; }
      b.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4.5 2.5L8 6l-3.5 3.5"/></svg>';
      return b;
    }
    function espreitar(el, seta) {
      return new Promise(function (feito) {
        var max = el.scrollWidth - el.clientWidth, de = el.scrollLeft;
        if (aprendeu || max < 24 || !el.offsetWidth) { feito(); return; }
        var d = max - de > 24 ? Math.min(64, max - de) : -Math.min(64, de);
        var snap = el.style.scrollSnapType, comp = el.style.scrollBehavior;
        el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto';
        var t0 = null, largou = false;
        function larga() { largou = true; }
        ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) { el.addEventListener(ev, larga, { passive: true, once: true }); });
        if (seta) seta.classList.add('ic-seta--chama');
        function fim(repor) {
          if (repor) el.scrollLeft = de;
          el.style.scrollSnapType = snap; el.style.scrollBehavior = comp;
          if (seta) seta.classList.remove('ic-seta--chama');
          feito();
        }
        function passo(t) {
          if (largou) { fim(false); return; }
          if (t0 === null) t0 = t;
          var p = t - t0, x;
          if (p < 420) { x = 1 - Math.pow(1 - p / 420, 3); }                       // vai, a abrandar
          else if (p < 700) { x = 1; }                                              // fica um instante
          else if (p < 1240) { var q = (p - 700) / 540; x = 1 - (q < .5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2); }  // volta
          else { fim(true); return; }
          el.scrollLeft = de + d * x;
          requestAnimationFrame(passo);
        }
        requestAnimationFrame(passo);
      });
    }
    todos(FILAS).forEach(function (el) {
      var pai = el.parentElement;
      if (!pai || el.icDesliza) return;
      el.icDesliza = true;
      if (getComputedStyle(pai).position === 'static') pai.style.position = 'relative';
      var dir = botao('ic-seta--dir', 'Ver mais'), esq = rato ? botao('ic-seta--esq', 'Ver os anteriores') : null;
      pai.appendChild(dir); if (esq) pai.appendChild(esq);
      var pedido = false;
      function estado() {
        pedido = false;
        var max = el.scrollWidth - el.clientWidth, x = el.scrollLeft, visto = el.offsetWidth > 0;
        var pequena = el.offsetHeight < 64;
        dir.hidden = !(visto && max - x > 8);
        dir.classList.toggle('ic-seta--pequena', pequena);
        dir.style.top = (el.offsetTop + el.offsetHeight / 2) + 'px';
        dir.style.left = (el.offsetLeft + el.offsetWidth - 8) + 'px';
        if (esq) {
          esq.hidden = !(visto && x > 8);
          esq.classList.toggle('ic-seta--pequena', pequena);
          esq.style.top = dir.style.top;
          esq.style.left = (el.offsetLeft + 8) + 'px';
        }
      }
      function pedir() { if (!pedido) { pedido = true; requestAnimationFrame(estado); } }
      // «Mãos» = a pessoa está a mexer na fila (dedo, roda ou rato). Só assim um deslize conta como dela.
      var maos = false, onde = 0, relogio = null;
      ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) {
        el.addEventListener(ev, function () { maos = true; onde = el.scrollLeft; clearTimeout(relogio); relogio = setTimeout(function () { maos = false; }, 1500); }, { passive: true });
      });
      el.addEventListener('scroll', function () { if (maos && Math.abs(el.scrollLeft - onde) > 30) aprender(); pedir(); }, { passive: true });
      function andar(s) { aprender(); el.scrollBy({ left: s * Math.max(140, el.clientWidth * .8), behavior: menos ? 'auto' : 'smooth' }); }
      dir.addEventListener('click', function () { andar(1); });
      if (esq) esq.addEventListener('click', function () { andar(-1); });
      // ⚠️ Vigia-se também o PAI: se o que está por cima da fila crescer (uma foto que chega), a fila
      // desce e a seta, que é posicionada à mão, ficava para trás.
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(pedir); ro.observe(el); ro.observe(pai); }
      if (rato) {
        var dentro = 0;
        var entra = function () { dentro++; dir.classList.add('ic-seta--vista'); if (esq) esq.classList.add('ic-seta--vista'); };
        var sai = function () { dentro = Math.max(0, dentro - 1); setTimeout(function () { if (!dentro) { dir.classList.remove('ic-seta--vista'); if (esq) esq.classList.remove('ic-seta--vista'); } }, 120); };
        [el, dir, esq].forEach(function (x) { if (x) { x.addEventListener('pointerenter', entra); x.addEventListener('pointerleave', sai); } });
      }
      window.addEventListener('resize', pedir, { passive: true });
      estado();
      if (menos || aprendeu || !('IntersectionObserver' in window)) return;
      // ⚠️ Cada fila espreita por si, 350 ms depois de entrar no ecrã. Já houve uma fila única para
      // todas (uma de cada vez), mas com duas filas na mesma secção a segunda esperava 1,6 s pela
      // primeira e muitas vezes a cliente já tinha passado: ficava sem espreitar. Se entram duas ao
      // mesmo tempo, a segunda sai 160 ms depois, e leem-se como uma onda.
      // ⚠️ Se nessa altura a fila já não está inteira no ecrã, não espreita às escuras: volta a esperar.
      function aVista() { var q = el.getBoundingClientRect(); return q.width > 0 && q.top >= 0 && q.bottom <= (window.innerHeight || document.documentElement.clientHeight); }
      function vigiar() {
        var ob = new IntersectionObserver(function (es) {
          if (!es[es.length - 1].isIntersecting) return;
          ob.disconnect();
          var atraso = 350 + onda * 160; onda++;
          setTimeout(function () { onda = Math.max(0, onda - 1); }, 400);
          setTimeout(function () {
            if (aprendeu) return;
            if (!aVista()) { setTimeout(vigiar, 600); return; }
            espreitar(el, dir);
          }, atraso);
        }, { threshold: .8 });
        ob.observe(el);
      }
      vigiar();
    });
  }

  function arrancar() {
    stories();
    todos('.ic-cartaz').forEach(cartaz);
    todos('.ic-montra').forEach(montra);
    todos('.ic-oferta').forEach(oferta);
    todos('.ic-mercado').forEach(mercado);
    adicionar();
    deslizar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
